module.exports = __webpack_public_path__ + "32fcca4f666d8f2ef54f9b3a2346d8d3.svg";